import api from '@/assets/plugins/axios'
import {backendUrl, authorization, aecore} from '@/assets/js/config'

// let headers = {'Content-type': 'application/x-www-form-urlencoded'};
let headers = {'Authorization': authorization, 'Content-type': 'application/json;charset=UTF-8'}
class UploadService {
  // 原有op系统
  // getFeedbackList(params){
  //   return api.get(`${backendUrl}/feedback/list`, params).then(ret => {
  //     return ret
  //   })
  // }
  // feedbackComment(params, query){
  //   return api.post(`${backendUrl}/feedback/${query}/comment`, params).then(ret => {
  //     return ret
  //   })
  // }
  // submitBackfeed(params){
  //   return api.post(`${backendUrl}/feedback`, params).then(ret => {
  //     console.log(ret)
  //     return ret
  //   })
  // }

  // 新接口 aecore
  // 1、新增反馈
  submitBackfeed (params) {
    return api.post(`${aecore}/portal/feedback/new`, params, headers).then(ret => {
      return ret
    })
  }

  // 3、用户反馈列表
  getFeedbackList ({pageSize, pageNum}) {
    return api.get(`${aecore}/portal/feedback/list`, {count: pageSize, page: pageNum}, headers).then(ret => {
      return ret
    })
  }

  // 4、获取栏目列表接口
  getCategoryList (params) {
    return api.get(`${aecore}/portal/category/list`, params, headers).then(ret => {
      return ret
    })
  }

}

export default new UploadService()
